<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">A few quick details before we move ahead​​</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">
                        <form [formGroup]="kycForm" (ngSubmit)="onSubmit()" novalidate>
                            <div class="row justify-content-center">
                                <div class="col-11 p-4">
                                    <!-- Employee Type -->
                                    <div class="form-group">
                                        <label class="control-label pb-3" style="font-weight: 400;">
                                            Your details help us understand your profile better and speed up your
                                            approval process so you can book your trip sooner.
                                        </label>

                                        <label class="control-label pb-2" style="text-align: left; width: 100%;">Select
                                            Your Employment Type</label>

                                        <div class="d-flex align-items-stretch gap-2 w-100 profession-cards">
                                            <div class="card shadow" *ngFor="let professionType of professionTypes"
                                                [ngClass]="{'active': professionType.isSelected}"
                                                (click)="onProfessionSelect(professionType)">

                                                <div class="card-body d-flex flex-column">
                                                    <div class="row h-100 flex-grow-1">
                                                        <div
                                                            class="col-md-6 col-12 d-flex justify-content-center align-items-center">
                                                            <p class="profession_type">{{ professionType.type }}</p>
                                                        </div>
                                                        <div class="col-md-6 col-12 profession_icon">
                                                            <img [src]="professionType.icon" alt="profession_icon"
                                                                class="img-fluid">
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div *ngIf="m.employeeType.touched && m.employeeType.invalid" class="error">
                                            Please select employee type
                                        </div>
                                    </div>
                                </div>
                                <div class="col-11 pl-4 pr-4">
                                    <!-- Educational Qualification -->
                                    <div class="form-group">
                                        <label class="control-label pb-2"
                                            style="width: 100%; text-align: left;">Educational Qualification</label>
                                        <select formControlName="educationalQualification" class="form-select">
                                            <option value="" selected disabled>Choose your highest education level
                                            </option>
                                            <option value="SECONDARY">Secondary</option>
                                            <option value="HIGHER_SECONDARY">Higher Secondary</option>
                                            <option value="GRADUATE">Graduate</option>
                                            <option value="POST_GRADUATE">Post Graduate</option>
                                        </select>
                                        <div *ngIf="m.educationalQualification.touched && m.educationalQualification.invalid"
                                            class="error">
                                            <div *ngIf="m.educationalQualification.errors?.required">
                                                Please select educational qualification
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center text-center buttonDiv">
                                <div class="col-12">
                                    <button class="btn btn-warning" [disabled]="!kycForm.valid" type="submit">
                                        Confirm & Continue
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>